import { Button, lighten, Paper, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import CourseForm from '../../course/course.form';

export default function CoursesStep(props) {
	const [subjects, setSubjects] = useState([]);

	const saveCourses = () => {
		props?.onNext?.();
	};

	return (
		<React.Fragment>
			{subjects.map((subject) => (
				<Paper sx={[props.sx, { backgroundColor: lighten(subject.colour, 0.8) }]} key={'subject-' + subject.name}>
					<Typography variant="h3">{subject.name}</Typography>
					<CourseForm />
				</Paper>
			))}

			<Stack justifyContent="space-between">
				<Button variant="contained" color="primary" sx={{ mt: 4 }} onClick={() => props?.onPrevious?.()}>Previous</Button>
				<Button variant="contained" color="primary" sx={{ mt: 4 }} onClick={() => saveCourses()}>Next</Button>
			</Stack>
		</React.Fragment>
	);
}